import { CONFERENCE_JOINED, ENDPOINT_MESSAGE_RECEIVED, UPDATE_CONFERENCE_METADATA } from '../base/conference/actionTypes';
import { getConferenceState } from '../base/conference/functions';
import { isLocalParticipantModerator } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { setFlip } from './actions';
import { ENDPOINT_MESSAGE_ASK_TO_SET_META } from './constants';
MiddlewareRegistry.register(store => next => (action) => {
    const result = next(action);
    switch (action.type) {
        case CONFERENCE_JOINED:
        case UPDATE_CONFERENCE_METADATA:
            const conference = getConferenceState(store.getState());
            if (!conference.metadata?.flip)
                return;
            store.dispatch(setFlip(conference.metadata.flip.participantIds));
            break;
        case ENDPOINT_MESSAGE_RECEIVED:
            const { data } = action;
            const { type } = data;
            switch (type) {
                case ENDPOINT_MESSAGE_ASK_TO_SET_META:
                    if (!isLocalParticipantModerator(store))
                        break;
                    const flip = data.payload;
                    store.dispatch(setFlip(flip.participantIds, true));
                    break;
            }
            break;
    }
    return result;
});
